export enum PaymentMethodEnum {
  CASH = 'CASH',
  BANK_TRANSFER = 'BANK_TRANSFER',
  PAYMENT_CARD = 'PAYMENT_CARD',
}
